<!--
 * @Author: RYL
 * @Description: 地图，使用地图切图和设备管理服务端保持一致
 * @Date: 2020-12-15 13:48:03
 * @LastEditTime: 2020-12-30 14:55:32
-->
<template>
  <div id="map"></div>
</template>
<script>
import L from 'leaflet'
import { GetLan, SetMapType, GetMapType } from "@/localStorage/localStorage";
import { coordtransform, mapTile } from '@/utils/mapUtils'
export default {
  props: ['devicesOption'],
  data() {
    return {
      map: null,
      markers: null,
      mapTile,
    }
  },
  mounted() {
    this.initMap()
  },
  watch: {
    devicesOption: {
      deep: true,
      handler() {
        this.setMarker()
      }
    }
  },
  methods: {
    initMap() {
      this.map = null
      let center = L.latLng(35.5, 108) // 中心点经纬度
      let mapType = GetMapType()
      let customerTiles =this.mapTile.tiles()
      if(mapType === 'Google地图' || mapType === 'Google Map') {
        customerTiles = this.mapTile.gooleTiles()
      }else if(mapType === 'openStreetMap') {
        customerTiles = this.mapTile.openTiles()
      }else{
        customerTiles = this.mapTile.tiles()
      }
      this.map = L.map('map', { 
        center: center,
        zoom: 4, // 缩放级别
        layers: [customerTiles], //添加图层到地图上
        zoomControl: false
      })
      this.setMarker()
    },
    // 聚合点渲染，独自抽取封装当数据变化时只刷新地图数据不刷新整个地图，不然会报错
    setMarker() {
      // 获取点
      if(this.markers !== null) {
        // 移除所有标记点
        this.map.removeLayer(this.markers)
      }
      // 聚合点设置
      this.markers = L.markerClusterGroup({
        showCoverageOnHover: false,
        zoomToBoundsOnClick: true, // true则点击一次就展开聚点，false则需要双击才点开
      })
      this.devicesOption.forEach(element => {
        // 存在经纬度才显示地址
        if(element.deviceLatitude && element.deviceLongitude) {
          let latLng = this.setLatLng(element.deviceLatitude, element.deviceLongitude)
          let content = `${element.deviceSn}${element.deviceName ? `（${element.deviceName}）` : ''}<br/>${element.deviceAddress ? element.deviceAddress : ''}`
          let m = L.marker(latLng)
          if(element.deviceName) {
                m.bindTooltip(`${element.deviceName}`, {permanent: true, className: "my-label", offset: [0, 0] })
              }
          m.bindPopup(content)
          this.markers.addLayer(m)
        }
      })
      this.map.addLayer(this.markers)
    },
    // 点击某个设备定点到某个位置
    setDeviceView(data) {
      if(data.deviceLatitude && data.deviceLongitude) {
        let latLng = this.setLatLng(data.deviceLatitude, data.deviceLongitude)
        this.map.setView(latLng, 13)
      }else{
        this.map.setView(L.latLng(35.5, 108), 4)
      }
    },
    // 处理坐标系
    setLatLng(deviceLatitude, deviceLongitude) {
      let mapType = GetMapType()
       let latLng = null
      if(mapType === 'openStreetMap') {
        let mypoint = coordtransform.gcj02towgs84(deviceLatitude, deviceLongitude)
        latLng = L.latLng(mypoint[0], mypoint[1])
      }else{
        latLng = L.latLng(deviceLatitude, deviceLongitude)
      }
      return latLng
    }
  }
}
</script>
<style scoped>
#map{
  height:100%;
  width: 100%;
}

</style>
<style>
.my-label {
  color: red;
  font-size: 17px;
  font-weight: bolder;
}
</style>